var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.editRecords, function (record, index) {
        return _c("div", { staticClass: "row block" }, [
          _c("div", { staticClass: "col-md-2" }, [
            _c("div", { staticClass: "created_info" }, [
              _c("p", [_c("UserName", { attrs: { id: record.user_id } })], 1),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(record.report_date || "сейчас")),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2 form-group" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("Валюта")]),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", readonly: "" },
              domProps: { value: _vm.currencies[record.currency_id].currency },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2 form-group" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("Количество")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: record.sum,
                  expression: "record.sum",
                },
              ],
              staticClass: "form-control",
              attrs: { disabled: record.to_delete, type: "text" },
              domProps: { value: record.sum },
              on: {
                keyup: function ($event) {
                  return _vm.updateRecord(index, "sum")
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(record, "sum", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2 form-group" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("Курс")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: record.displayRate,
                  expression: "record.displayRate",
                },
              ],
              staticClass: "form-control",
              attrs: { disabled: record.to_delete, type: "text" },
              domProps: { value: record.displayRate },
              on: {
                keyup: function ($event) {
                  return _vm.updateRecord(index, "displayRate")
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(record, "displayRate", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2 form-group" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("На сумму")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: record.total,
                  expression: "record.total",
                },
              ],
              staticClass: "form-control",
              attrs: { disabled: record.to_delete, type: "text" },
              domProps: { value: record.total },
              on: {
                keyup: function ($event) {
                  return _vm.updateRecord(index, "total")
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(record, "total", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-md-2 form-group flex align-self-end justify-content-end",
            },
            [
              !_vm.disableToSaveRate
                ? _c("div", [
                    _c("label", { attrs: { for: `gridCheck_${index}` } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: record.saveRate,
                            expression: "record.saveRate",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: { type: "checkbox", id: `gridCheck_${index}` },
                        domProps: {
                          checked: Array.isArray(record.saveRate)
                            ? _vm._i(record.saveRate, null) > -1
                            : record.saveRate,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = record.saveRate,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    record,
                                    "saveRate",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    record,
                                    "saveRate",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(record, "saveRate", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("сохранить курс")]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  on: {
                    click: function ($event) {
                      record.to_delete = !record.to_delete
                    },
                  },
                },
                [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
              ),
            ]
          ),
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex justify-content-between p-t-10" },
        [
          _c("div", [
            _c("div", { staticClass: "input-group" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newCurrencyId,
                      expression: "newCurrencyId",
                    },
                  ],
                  staticClass: "custom-select",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.newCurrencyId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { disabled: "", value: "0" } }, [
                    _vm._v("Выберите валюту"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.allowToBuy, function (currency, id) {
                    return _c("option", { domProps: { value: id } }, [
                      _vm._v(_vm._s(currency) + "\n          "),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "button",
                  { staticClass: "btn btn-info", on: { click: _vm.addNew } },
                  [_vm._v("Купить")]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "vue-ladda",
            {
              attrs: {
                "button-class": "btn btn-success",
                "data-style": "zoom-in",
                loading: _vm.loading,
              },
              on: { click: _vm.save },
            },
            [_vm._v("Сохранить валюты\n    ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }